import produce from 'immer';
import create from 'zustand';

const useAnnouncementModalStore = create(set => ({
  currentAnnouncement: {
    id: null,
    name: null,
    heroImageUrl: null,
    headline: null,
    copy: null,
    buttonCopy: null,
    buttonLink: null,
  },
  show: false,
  set: fn => set(produce(fn)),
}));

export default useAnnouncementModalStore;
